import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/id'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { Ckeditor } from '@ckeditor/ckeditor5-vue'

import { createBootstrap } from 'bootstrap-vue-next'

import '@/assets/scss/core.scss'
import 'vue3-perfect-scrollbar/style.css'
import '@/assets/scss/pages/app-email.scss'
import '@/assets/scss/flatpickr.scss'
import '@/assets/fonts/iconify-icons.css'
import '@vueform/multiselect/themes/default.css'
import '@tato30/vue-pdf/style.css'

import { useAuthStore } from '@/stores/auth'

import '@/utils/validate'

import {CkeditorPlugin } from '@ckeditor/ckeditor5-vue'
import VValidate from '@/components/VValidate.vue'

import Swal from 'sweetalert2'
window.Swal = Swal

import App from './App.vue'
import router from './router'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.locale('id')

const app = createApp(App)

app.config.globalProperties.$dayjs = dayjs
app.config.warnHandler = function () {
  return null
}

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(CkeditorPlugin )

app.use(createBootstrap())
app.use(router)
app.component('VValidate', VValidate)
app.use(Ckeditor)

const initAuth = async () => {
  const auth = useAuthStore()
  try {
    await auth.watchAuth() // load token dari localStorage dan refresh profil user jika valid
  } catch (err) {
    console.error(err)
  } finally {
    document.getElementById('pLoader')?.remove()
    app.mount('#app')
  }
}

initAuth()
